import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children"];
import React, { forwardRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { cnBem } from "../../../../shared/lib";
import { useAppSelector } from "../../../../shared/model";
import { selectIsFiltersVisible } from "../../../../entities/filters/model";
import styles from "./styles.pcss";
var cnHeader = cnBem('header', styles);
var variants = {
  enter: function enter(view) {
    return {
      x: view === 'main' ? 1000 : -1000,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: function exit(view) {
    return {
      zIndex: 0,
      x: view !== 'main' ? 1000 : -1000,
      opacity: 0
    };
  }
};
export var Header = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isFiltersVisible = useAppSelector(selectIsFiltersVisible);
  var view = isFiltersVisible ? 'main' : 'search';
  return /*#__PURE__*/React.createElement("header", _extends({
    className: cnHeader(null, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "ui-Header"
  }), /*#__PURE__*/React.createElement(AnimatePresence, {
    custom: view,
    initial: false
  }, /*#__PURE__*/React.createElement(motion.div, {
    animate: "center",
    className: cnHeader('container'),
    custom: view,
    exit: "exit",
    initial: "enter",
    key: view,
    ref: ref,
    transition: {
      x: {
        duration: 0.5
      },
      opacity: {
        duration: 0.2
      }
    },
    variants: variants
  }, children)));
});